module.exports = __webpack_public_path__ + "img/operations.8def28aa.svg";